import Repository from './Repository';

class SettingRepository extends Repository {
	getSettings () {
		return this.getWithToken('/settings');
	}
}

export default new SettingRepository();
